import { Badge } from "@volca/ui/components/ui/badge";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import type { AccessArea, AccessAssignment, AccessKeySetting } from "./types";
import { areaName } from "./utils";

interface AccessChipsProps {
  rows: AccessAssignment[];
  keySettings: AccessKeySetting[];
  areas: AccessArea[];
}

export const AccessChips = ({ rows, keySettings, areas }: AccessChipsProps) => {
  if (rows.length === 0) {
    return <Text tone="muted">No access</Text>;
  }
  const ordered = [...rows].sort(
    (a, b) => Number(b.full_workbook_access) - Number(a.full_workbook_access),
  );
  return (
    <Stack align="start" direction="row" gap={1} className="min-w-0 flex-wrap">
      {ordered.map((row) => {
        const scope = row.full_workbook_access
          ? "Whole workbook"
          : areaName(row.access_key, keySettings, areas);
        const extras = [
          row.approval_access && "approves",
          row.notify_pack_questions && "pay questions",
        ].filter(Boolean);
        return (
          <Badge
            key={`${row.full_workbook_access}-${row.access_key}`}
            variant="secondary"
            color={row.full_workbook_access ? "blue" : "neutral"}
            size="sm"
            className="max-w-full whitespace-normal"
          >
            {scope}: {row.access_level === "edit" ? "edit" : "view"}
            {extras.length > 0 ? `, ${extras.join(", ")}` : ""}
          </Badge>
        );
      })}
    </Stack>
  );
};
